


















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { Languages } from 'modules/core/enums/languages';

@Component({
  name: 'language-picker',
})
export default class LanguagePicker extends Vue {
  @Prop() public currentLang!: Languages;
  public languages: string[] = Object.values(Languages);

  public getImageUrl(lang: Languages) {
    return require(`assets/langs/${lang}.png`);
  }

  public changeLanguage(lang: Languages) {
    this.$emit('langUpdate', lang);
  }
}
